import type {
  ConnectorConnection,
  ConnectorConnectionApiResponse,
  ConnectorConnectionListApiResponse,
  ConnectorConnectionListResponse,
  ConnectorProject,
  ConnectorProjectApiResponse,
  ConnectorProjectListApiResponse,
  ConnectorProjectListResponse,
  ConnectorProvider,
  ConnectorProviderApiResponse,
  OAuthCallbackApiResponse,
  OAuthCallbackResponse,
  OAuthInitiateApiResponse,
  OAuthInitiateResponse,
} from './connector.interface'

export const transformConnectorProviderFromApi = (
  response: ConnectorProviderApiResponse
): ConnectorProvider => ({
  slug: response.slug,
  displayName: response.display_name,
  isConnected: response.is_connected,
  serviceTypeList: response.service_types,
})

export const transformConnectorConnectionFromApi = (
  response: ConnectorConnectionApiResponse
): ConnectorConnection => ({
  id: response.id,
  tenantId: response.tenant_id,
  userId: response.user_id,
  provider: response.provider,
  status: response.status,
  providerAccountId: response.provider_account_id,
  scopeList: response.scopes,
  tokenExpiresAt: response.token_expires_at,
  createdAt: response.created_at,
  updatedAt: response.updated_at,
})

export const transformConnectorProjectFromApi = (
  response: ConnectorProjectApiResponse
): ConnectorProject => ({
  id: response.id,
  tenantId: response.tenant_id,
  connectionId: response.connection_id,
  provider: response.provider,
  serviceType: response.service_type,
  externalId: response.external_id,
  displayName: response.display_name,
  isActive: response.is_active,
  createdAt: response.created_at,
  updatedAt: response.updated_at,
})

export const transformConnectorConnectionListFromApi = (
  response: ConnectorConnectionListApiResponse
): ConnectorConnectionListResponse => ({
  itemList: response.items.map(transformConnectorConnectionFromApi),
  total: response.total,
})

export const transformConnectorProjectListFromApi = (
  response: ConnectorProjectListApiResponse
): ConnectorProjectListResponse => ({
  itemList: response.items.map(transformConnectorProjectFromApi),
  total: response.total,
})

export const transformOAuthInitiateFromApi = (
  response: OAuthInitiateApiResponse
): OAuthInitiateResponse => ({
  authUrl: response.auth_url,
})

export const transformOAuthCallbackFromApi = (
  response: OAuthCallbackApiResponse
): OAuthCallbackResponse => ({
  connection: transformConnectorConnectionFromApi(response.connection),
  projectList: response.projects.map(transformConnectorProjectFromApi),
})
